import React from 'react'
import {
  BottomSliderModal,
  BottomSliderModalProps,
  BottomSliderModalHeader,
  BottomSliderModalCloseButton,
} from '@/checkout-instore-legacy/components/Commons/BottomSliderModal'
import { InstallmentsContent } from './InstallmentsContent'
import { FormattedMessage } from 'react-intl'
import { Installment } from '@/checkout-instore-legacy/product/typings'
import { Text, csx } from '@vtex/admin-ui'

type Props = {
  installments: Installment[]
  sellingPriceCents: number
} & BottomSliderModalProps

export const InstallmentsModal = ({
  installments,
  sellingPriceCents,
  ...props
}: Props) => (
  <BottomSliderModal {...props}>
    <BottomSliderModalHeader className={csx({ borderBottom: 'none' })}>
      <Text variant="title1">
        <FormattedMessage
          id="paymentMethod"
          // FormattedMessage renders a span as default, overriding the styles of the Text component above.
          // It would be better if FormattedMessage renders a React.fragment.
          children={(text: any) => <>{text}</>}
        />
      </Text>
      <BottomSliderModalCloseButton data-testid="installments-modal-close-button" />
    </BottomSliderModalHeader>
    <InstallmentsContent
      installments={installments}
      sellingPriceCents={sellingPriceCents}
    />
  </BottomSliderModal>
)
